import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { WindowService } from 'src/app/services/local/window.service';
import { storageKeys } from 'src/app/share/configs';
import { AuthService } from 'src/app/services/apis/auth.service';
import { MessageService } from 'src/app/share/components/message/message.service';
import { StoreService } from 'src/app/services/apis/store.service';
import { StoreRes } from 'src/app/share/types';
import { StoreInfoStoreModule } from 'src/app/state/store-info/store-info.store.module';
import { Store } from '@ngrx/store';
import { setStoreInfo } from 'src/app/state/store-info/action';
import { ShoppingCartStoreModule } from 'src/app/state/shopping-cart/shopping-cart.store.module';
import {
  setShoppingCart,
  setShoppingCartLength,
} from 'src/app/state/shopping-cart/action';

@Component({
  selector: 'uo-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  isLog: boolean = false;
  stores!: StoreRes[];

  constructor(
    private router: Router,
    private winServe: WindowService,
    private cdr: ChangeDetectorRef,
    private storeServe: StoreService,
    private messageServe: MessageService,
    private storeStore$: Store<StoreInfoStoreModule>,
    private shoppingCartStore$: Store<ShoppingCartStoreModule>,
    private authServe: AuthService
  ) {}
  
  ngOnDestroy(): void {
    // No subscriptions to clean up
  }

  ngOnInit(): void {
    this.setIsLog();
    this.getStores();
  }

  getStores(): void {
    this.loading = true;
    this.cdr.markForCheck();
    this.storeServe.getStores().subscribe(
      (res) => {
        console.log('getStores :>> ', res);
        this.stores = res.data.values;
        // Shuffle stores to show them randomly
        if (this.stores && this.stores.length > 0) {
          this.stores = this.shuffleArray([...this.stores]);
        }
      },
      () => {},
      () => {
        this.loading = false;
        this.cdr.markForCheck();
      }
    );
  }

  private shuffleArray<T>(array: T[]): T[] {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
  setIsLog(): void {
    if (this.winServe.getLocalStorage(storageKeys.auth)) {
      this.isLog = true;
    }
  }
  storeTrackBy(index: number, store: StoreRes): number {
    return store.id;
  }
  selectStore(store: StoreRes): void {
    this.storeStore$.dispatch(setStoreInfo(store));
    this.winServe.setLocalStorage(storageKeys.store, store.id.toString());
    this.router.navigate(['/store', store.id]);
  }
  onSignUp() {
    this.router.navigate(['sign-up']);
  }
  onSignIn() {
    this.router.navigate(['sign-in']);
  }
  onLogout() {
    this.isLog = false;
    this.messageServe.warning('Log out');
    this.cdr.markForCheck();
    this.authServe
      .logout(this.winServe.getLocalStorage(storageKeys.user) as string)
      .subscribe(
        (res) => {
          console.log('res :>> ', res);
          this.winServe.removeLocalStorage(storageKeys.auth);
          this.winServe.removeLocalStorage(storageKeys.user);
          this.winServe.removeLocalStorage(storageKeys.userFirstName);
          this.winServe.removeLocalStorage(storageKeys.userLastName);
          this.shoppingCartStore$.dispatch(
            setShoppingCartLength({ length: 0 })
          );
          this.shoppingCartStore$.dispatch(
            setShoppingCart({
              cart: [],
            })
          );
        },
        (err) => {
          this.winServe.removeLocalStorage(storageKeys.auth);
          this.winServe.removeLocalStorage(storageKeys.user);
          this.winServe.removeLocalStorage(storageKeys.userFirstName);
          this.winServe.removeLocalStorage(storageKeys.userLastName);
          this.shoppingCartStore$.dispatch(
            setShoppingCartLength({ length: 0 })
          );
          this.shoppingCartStore$.dispatch(
            setShoppingCart({
              cart: [],
            })
          );
        }
      );
  }
}
